module.exports = __webpack_public_path__ + "img/qrcode.c2d7c648.svg";